module.exports = __webpack_public_path__ + "static/media/MainPage_8m.9b93917c.png";